export default __webpack_public_path__ + "static/media/background.c5401fd2.jpg";